export type CharacterFilterNavigateResult =
  | { mode: 'single-permalink'; characterId: string; fandomId: string }
  | { mode: 'selection-change'; characterIds: string[] };

/**
 * One character with no fandom selected must include the character's fandomId so
 * /seo/redirect can open /fanfics/fandoms/{fandom}/characters/{slug}. Multi-select
 * stays on the regular characters change path (query URL).
 */
export const resolveCharacterFilterNavigate = ({
  updatedCharacterIds,
  selectedFandomIds,
  characterFandomId,
}: {
  updatedCharacterIds: string[];
  selectedFandomIds: string[];
  characterFandomId?: string;
}): CharacterFilterNavigateResult => {
  const [characterId] = updatedCharacterIds;
  if (
    updatedCharacterIds.length === 1 &&
    selectedFandomIds.length === 0 &&
    characterId &&
    characterFandomId
  ) {
    return {
      mode: 'single-permalink',
      characterId,
      fandomId: characterFandomId,
    };
  }

  return {
    mode: 'selection-change',
    characterIds: updatedCharacterIds,
  };
};
